import { useTranslation } from 'react-i18next';
import {
    Chip,
} from '@material-ui/core';
import {
    Table, Whisper, Popover,
} from 'rsuite';
import './ArchiveListNameCell.scss';
import { Icon as MdiIcon } from '@mdi/react';
import { mdiStarBox } from '@mdi/js';
import { ColoredDot } from '@commonClient2/components';
import { getProfileStatusLabel } from '../../../Enums/Helpers/LabellingHelper';
import { getProfileStatusColor } from '../../../Enums/Helpers/StylingHelper';

const { Cell } = Table;

/**
 * @param {{
 *  rowData: BidProfile.IBriefBaseProfile | BidProfile.IBidProfileRebid,
 *  dataKey: string,
 *  handleNameClick: (row: BidProfile.IBriefBaseProfile) => void,
 *  iconTooltipLabel: string,
 * }} ArchiveListNameCellProps
 */
const ArchiveListNameCell = ({
    rowData, dataKey, handleNameClick, iconTooltipLabel, ...props
}) => {
    const { t } = useTranslation('shiftBidding');

    const tooltipStatus = (
        <Popover visible>
            {getProfileStatusLabel(rowData.status)}
        </Popover>
    );
    const tooltipName = (
        <Popover
            className="blnc-popover-name"
            visible
        >
            {rowData.name}
        </Popover>
    );
    const tooltipParentIcon = (
        <Popover visible>
            {iconTooltipLabel}
        </Popover>
    );

    return (
        <Cell
            {...props}
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}//  : 'default'
            dataKey={dataKey}
            onClick={() => (handleNameClick(rowData))}// : () => { }
        >
            <Whisper
                placement="autoVerticalStart"
                delay={500}
                delayOpen={500}
                delayClose={500}
                speaker={tooltipStatus}
            >
                <span className="blnc-chipTagStatus">
                    <ColoredDot style={getProfileStatusColor(rowData.status, false)} />
                </span>
            </Whisper>
            <Whisper
                delay={500}
                delayOpen={500}
                delayClose={500}
                placement="autoVerticalStart"
                speaker={tooltipName}
            >
                <span className="blnc-name-cell-label">
                    {rowData.name}
                </span>
            </Whisper>
            {
                // @ts-ignore
                !!rowData.rebidNumber
                && (
                    <Chip
                        label={t('common.rebidNumber', { number: rowData.rebidNumber })}
                        variant="outlined"
                        className="blnc-rebid-chip"
                    />
                )
            }
            {
                rowData.isOriginalBid
                && (
                    <Whisper
                        delay={500}
                        delayOpen={500}
                        delayClose={500}
                        placement="bottom"
                        speaker={tooltipParentIcon}
                    >
                        <MdiIcon
                            className="blnc-original-bid-icon"
                            path={mdiStarBox}
                            size={1}
                        />
                    </Whisper>
                )
            }
        </Cell>
    );
};

export default ArchiveListNameCell;
